/* @flow weak */
import Box from 'components/Box.jsx';
import Columns from 'components/Columns.jsx';
import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import OrganizationDetails from 'admin/entities/OrganizationDetails';
import React from 'react';
import Text from 'components/Text.jsx';

import './styles/SchoolStatsTab.scss';

class SchoolStatsTab extends React.Component {
  static contextTypes = {
    group: React.PropTypes.instanceOf(Group).isRequired,
  };

  state = {
    orgDetails: null,
  };

  componentDidMount() {
    // XXX get rid of promise, use Flux
    const orgId = this.context.group.getStaffClassOrgId();
    OrganizationDetails.getByOrganizationId(orgId)
      .then(orgDetails => this.setState({ orgDetails }))
      .catch(e => console.error('SchoolStatsTab getByOrganizationId failed', e));
  }

  announcementsPerTeacher = () => {
    const messages = this.state.orgDetails.getMessageCount();
    const teachers = this.state.orgDetails.getTeacherCount();
    // avoid NaN and Infinity
    if (messages > 0 && teachers > 0) {
      return (messages / teachers).toFixed(1);
    }
    return 0;
  };

  renderStat = (value, label) => {
    return (
      <div className="SchoolStatsTab-stat">
        <Text size="xxxxlarge">
          {value.toLocaleString(CurrentUser.getUser().getLocale())}
        </Text>
        <br />
        <Text size="xsmall" color="thunder">{label}</Text>
      </div>
    );
  };

  render() {
    if (!this.state || !this.state.orgDetails) {
      return (
        <div className="ChatList-loading">
          <LoadingIndicator size="small" />
        </div>
      );
    }

    return (
      <div className="SchoolStatsTab">
        <div className="SchoolStatsTab-pageTitle">
          <h1>
            <Text size="large">
              Statistics
            </Text>
          </h1>
        </div>
        <Box className="SchoolStatsTab-statBox">
          <div className="SchoolStatsTab-statTitle">
            School statistics
          </div>
          <Columns>
            {this.renderStat(this.state.orgDetails.getTeacherCount(), 'Teachers')}
            {this.renderStat(this.state.orgDetails.getSubscriberCount(), 'Participants')}
            {this.renderStat(this.state.orgDetails.getClassCount(), 'Classes')}
          </Columns>
        </Box>
        <Box className="SchoolStatsTab-statBox">
          <div className="SchoolStatsTab-statTitle">
            Activity in the last 30 days
          </div>
          <Columns>
            {this.renderStat(this.state.orgDetails.getMessageCount(), 'Announcements sent')}
            {this.renderStat(this.announcementsPerTeacher(), 'Announcements sent per teacher')}
          </Columns>
        </Box>
      </div>
    );
  }
}

export default SchoolStatsTab;



// WEBPACK FOOTER //
// ./src/groups/components/SchoolStatsTab.jsx